import { PreloaderCircular } from '@shared/ui/kit';
import { FC } from 'react';
import styles from './send-progress-loader.module.scss';

interface SendProgressLoaderProps {
  title?: string;
  subtitle?: string;
}

export const SendProgressLoader: FC<SendProgressLoaderProps> = ({
  title = 'Уже отправляем приглашения',
  subtitle = 'Подождите немного',
}) => (
  <div className={styles.root}>
    <PreloaderCircular variant="accent" size="l" />
    <div className={styles.textBlock}>
      <p className={styles.title}>{title}</p>
      <p className={styles.subtitle}>{subtitle}</p>
    </div>
  </div>
);
